import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class IsCreditDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/isCreditDealer',
      requesterInfo,
    })
  }

  public async isCompay(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
